// https://github.com/BrooonS/timezz

import timezz from 'timezz';

const elements = document.querySelectorAll('.js-countdown');

elements.forEach(el => {
  const data_date = el.getAttribute('data-date');

  timezz(el, {
    date: new Date(data_date)
  });
});
